
import BusinessForm from '~/components/BusinessForm.vue'
export default {
  name: 'BusinessFormSlice',
  props: ['slice'],
  components: { BusinessForm },
  data() {
    return {
      toggleForm: false,
      formSubmitted: false
    }
  },
  methods: {
    handleFormSubmitted(){
      this.toggleForm = false
      this.formSubmitted = true
      document.querySelector(`#${this.slice.primary.s_id || this.slice.primary.form_id}`).scrollIntoView({behavior: "smooth"})
    }
  }
}
